import { STREAMING_CURSOR_CHAR } from '@/constants/chat';

export const splitStreamingCursorContent = (content: string): { body: string; showCursor: boolean } => {
  if (content.endsWith(STREAMING_CURSOR_CHAR)) {
    return { body: content.slice(0, -STREAMING_CURSOR_CHAR.length), showCursor: true };
  }
  return { body: content, showCursor: false };
};

export const stripStreamingCursor = (content: string): string => {
  if (!content.endsWith(STREAMING_CURSOR_CHAR)) return content;
  return content.slice(0, -STREAMING_CURSOR_CHAR.length);
};
